import React from "react";

const LinkBigIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 39'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9818 7.83753L19.2497 3.63278C21.9485 1.28307 25.9654 1.5304 28.3504 4.12745C30.5472 6.47717 30.5472 10.1254 28.3504 12.5369L24.0197 16.7417L25.3378 18.0402L29.6685 13.7736C32.8694 10.6201 32.7439 5.42598 29.4802 2.27242C26.2792 -0.757473 21.1954 -0.757473 17.9944 2.27242L13.6637 6.47717C10.4628 9.69256 10.4628 14.8248 13.6637 18.0402L14.9818 16.7417C12.534 14.2683 12.534 10.3109 14.9818 7.83753Z'
        fill='white'
      />
      <path
        d='M14.2283 36.0343L18.559 31.8296C21.76 28.6142 21.76 23.4819 18.559 20.3284L17.241 21.6269C19.7515 24.1003 19.7515 28.0577 17.241 30.5311L12.9103 34.7358C10.3997 37.2092 6.38284 37.2092 3.87229 34.7358C1.36174 32.2624 1.36174 28.305 3.87229 25.8316L8.20299 21.6269L6.88495 20.3284L2.61702 24.5331C-0.709458 27.6248 -0.897749 32.7571 2.24044 36.0343C5.37862 39.3116 10.588 39.4971 13.9145 36.4053C14.04 36.2198 14.1655 36.158 14.2283 36.0343Z'
        fill='white'
      />
      <path
        d='M22.0392 14.7402L20.7078 13.4285L10.3228 23.6597L11.6542 24.9714L22.0392 14.7402Z'
        fill='white'
      />
    </svg>
  );
};

export default LinkBigIcon;
